import React from 'react';
import { Box, Typography, Paper, Link } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

function Help() {
  return (
    <Box sx={{ maxWidth: 700, mx: 'auto', mt: 6, mb: 6, px: 2 }}>
      <Paper elevation={3} sx={{ p: { xs: 2, md: 4 }, backgroundColor: '#fff' }}>
        <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
          <img
            src="/images/race-with-me-logo-blue.png"
            alt="RaceWithMe - F1 Game Racing Community Logo"
            style={{ height: '80px', maxWidth: '100%', objectFit: 'contain' }}
          />
        </Box>
        <Typography variant="h4" sx={{ fontFamily: '"Orbitron", "Roboto", "Helvetica", "Arial", sans-serif', fontWeight: 700, mb: 2, color: 'primary.main' }}>
          Help & About
        </Typography>
        <Typography variant="body1" sx={{ mb: 2 }}>
          For our privacy policy, including what data we collect and how we use it, see{' '}
          <Link component={RouterLink} to="/privacy" sx={{ fontWeight: 600, color: 'primary.main' }}>
            Privacy Policy
          </Link>.
        </Typography>
        <Typography variant="h6" sx={{ fontWeight: 600, mb: 1 }}>
          What is Race With Me?
        </Typography>
        <Typography variant="body1" sx={{ mb: 2 }}>
          Race With Me is designed to help F1 game players connect and race together. The site gives users the chance to:
        </Typography>
        <ul style={{ marginBottom: 24 }}>
          <li>
            <Typography variant="body1">
              Find a partner for 2 player career mode
            </Typography>
          </li>
          <li>
            <Typography variant="body1">
              Start up unranked lobbies with like-minded and hopefully clean drivers
            </Typography>
          </li>
          <li>
            <Typography variant="body1">
              Advertise or reserve a spot in league races
            </Typography>
          </li>
          <li>
            <Typography variant="body1">
              Find commentators for your league race events
            </Typography>
          </li>
          <li>
            <Typography variant="body1">
              Advertise your new league and find drivers to join the grid
            </Typography>
          </li>
        </ul>
        <Typography variant="h6" sx={{ fontWeight: 600, mb: 1 }}>
          How does it work?
        </Typography>
        <Typography variant="body1" sx={{ mb: 2 }}>
          When you register, we collect your EA ID. This EA ID will be shared with other players when you create a race card or your application to a card is accepted, making it easy for others to contact and connect with you for racing opportunities.
        </Typography>
        <Typography variant="h6" sx={{ fontWeight: 600, mb: 1 }}>
          Need help or have an issue?
        </Typography>
        <Typography variant="body1">
          If you have any questions or run into any issues, please contact us at:
          <br />
          <Link href="mailto:racewithmehelp@gmail.com" sx={{ fontWeight: 600, color: 'primary.main' }}>
            racewithmehelp@gmail.com
          </Link>
        </Typography>
      </Paper>
    </Box>
  );
}

export default Help; 